angular.module('cvsApp').service('authenticateGuestUserService',['networkService', 'xdrService', 'authenticateGuestUserModel', 'configManager', function (NS, XS, AGUM, CM) {
   	
	function authenticateGuestUserService (){	
		this.authenticateGuestUser = function(req, callBackSuccess){
			//get url 
			var url = CM.getGuestUrl('AUTH_GUEST_USER');
			var request = {url:url,
                            header:{"Content-Type":"application/xml"},
                            data:getRequestBody(req),
                            onSuccess:callBackSuccess
                        };
			cvsUtility.commonServiceCode(url,"authenticateGuestUser",AGUM,request,callBackSuccess,NS);
							
		};
        /**
         SMP 125 - Specialty Android Registration Enhancements - Nov 2017 release
         SP 10182017 - Modified function to support text format of date of birth
         */
		var getRequestBody = function(req){
			var timeStamp=cvsUtility.getTimeStamp();
			var dob= req.dob.indexOf('/')> -1 ? req.dob.split('/') : req.dob;
				
			var requestJson = {request:{
							tokenID:req.tokenId,
							tokenType:'Partial-Login',
							apiKey:cvsUtility.queryMap.apikey,
							timestamp:timeStamp,
							zipCode:req.zipCode,
							dateOfBirth: Array.isArray(dob)?  (dob[2]+"-"+dob[0]+"-"+dob[1]) : dob
						}};
			
			return cvsUtility.JSONToXml(requestJson);

			
		};			
	}
	
	return new authenticateGuestUserService();	
}]);
